import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { MainService} from './main.service';

@Injectable()
export class UserDeviceService {

  constructor(public http: Http, public mainService: MainService) { }

  findAll() {
    let promise = new Promise((resolve, reject) => {
      this.http.get(this.mainService.server_url+"userDevice")
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  create(userDevice:any){
    let promise = new Promise((resolve, reject) => {
      this.http.post(this.mainService.server_url+"userDevice",userDevice)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  edit(userDevice:any){
    let promise = new Promise((resolve, reject) => {
      this.http.put(this.mainService.server_url+"userDevice/id;idUser="+userDevice.idUser+";idDevice="+userDevice.idDevice,userDevice)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  remove(idUser:String,idDevice:String){
    let promise = new Promise((resolve, reject) => {
      this.http.delete(this.mainService.server_url+"userDevice/id;idUser="+idUser+";idDevice="+idDevice)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/user-device.service.ts